import request from './../utils/request'

export function index(params) {
    return request({
        url: '/columns',
        method: 'get',
        params
    })
}

export function store(data) {
    return request({
        url: '/columns',
        method: 'post',
        data
    })
}
